const akbDots = () => {
  const slides = [... document.querySelectorAll('.product-images__slide')];
  const dots = [... document.querySelectorAll('.akb-dot')];
  const slider = document.getElementById('Product-Slider');
  let mobileLayout = window.innerWidth < 1068 ? true : false;

  const addEventListeners = () => {
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function(event) {
        let id = dot.dataset.imageid;

        if ( !id ) {
          console.warn('No imageID on button. Returning');
          return false;
        }

        if ( id ) {
          removeClasses();
          findSlide(id);
          this.classList.add('akb-active');
        }
      });
    });

    // Slider only scrolls on mobile
    slider.addEventListener('scroll', function(event) {
      calcSlidePositionMobile();
    });

    window.addEventListener('scroll', function(event) {
      calcSlidePosition();
    });

    window.addEventListener('resize', function() {
      mobileLayout = window.innerWidth < 1068 ? true : false;
    });
  }


  const calcSlidePosition = () => {
    let scrollAmount = slider.scrollLeft;

    slides.forEach((slide, index) => {
      let dimensions = slide.getBoundingClientRect();

      if ( dimensions.top > -100 && dimensions.top < 300 ) {
        let id = slide.dataset.akbid;

        if ( id ) {
          removeClasses();
          findDot(id);

          if ( !slide.classList.contains('akb-active') ) {
            slide.classList.add('akb-active');
          }
          
        }
      }
    });
  }


  const calcSlidePositionMobile = () => {
    let scrollAmount = slider.scrollLeft;

    slides.forEach((slide, index) => {
      let dimensions = slide.getBoundingClientRect();
      
      if ( dimensions.left > -100 && dimensions.left < 100 ) {
        let id = slide.dataset.akbid;

        if ( id ) {
          removeClasses();
          findDot(id);

          if ( !slide.classList.contains('akb-active') ) {
            slide.classList.add('akb-active');
          }
          
        }
      }
    });
  }


  const findDot = (id) => {
    dots.forEach((dot, index) => {
      let dotId = dot.dataset.imageid;

      if ( dotId === id & !dot.classList.contains('akb-active') ) {
        dot.classList.add('akb-active');
      }
    });
  }
  

  const findSlide = (id) => {
    slides.forEach((slide, index) => {
      let slideId = slide.dataset.akbid;

      if ( slideId === id ) {
        if ( !slide.classList.contains('akb-active') ) {
          slide.classList.add('akb-active');
        }
        
        if ( mobileLayout ) {
          slide.scrollIntoView({ behavior: "smooth", inline: "nearest" });
        } else {
          slide.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
        
      }
    });
  }


  const removeClasses = () => {
    dots.forEach((dot, index) => {
      if ( dot.classList.contains('akb-active') ) {
        dot.classList.remove('akb-active');
      }
    });

    slides.forEach((slide, index) => {
      if ( slide.classList.contains('akb-active') ) {
        slide.classList.remove('akb-active');
      }
    });
  }

  addEventListeners();
}

akbDots();